import { useEffect, useState } from "react";
import Navbar from "../components/Navbar"
import {AiOutlineSearch} from "react-icons/ai"
import "../Styles/Wishlist.css"
import ProductCard from "../components/ProductCard";
import ProductPreview from "../components/ProductPreview";
import { Pagination } from '@mantine/core';
import {MdOutlineDeleteForever} from "react-icons/md"
import Footer from "../components/Footer";
import ServiceCard from "../components/ServiceCard";
import Cookies from "js-cookie";
import { toast } from "react-toastify";


const WishList = () => {
    const [activePage, setPage] = useState(1)
    const [productPreview, setProductPreview] = useState(false)
    const [products, setProducts] = useState([])
    const [query, setQuery] = useState("")
    const [data, setData] = useState({})
    

    const openProductPreview = (data) => {
        setProductPreview(true)
        setData(data)
    };
    
    const closeProductPreview = () => {
        setProductPreview(false);
    };
    useEffect(() => {
        let wishlist = localStorage.getItem('wishlist');
        if (!wishlist || !Cookies.get('TOKEN')) {
            setProducts([]);
        } else {
            setProducts(JSON.parse(wishlist))
        }
    }, [query, closeProductPreview])


    const removeItem = (id) => {
        const productToRemove = products.findIndex(item => item.id === id);
        if(productToRemove !== -1){
            products.splice(productToRemove, 1)
        }

        localStorage.setItem("wishlist", JSON.stringify(products))
    }

   

    return<>
        <Navbar/>
        <section className="search">
            <div className="searchInput">
                <AiOutlineSearch/>
                <input type="search" name="" id="" value={query} placeholder="Search Keyword..." onChange={(e) => setQuery(e.target.value)}/>
            </div>
        </section>

        <div className="wishlistWrapper">
        {
            products.filter(item => item.name.includes(query)).map((data) => {
                return<>
                    <div className="cardWrapper">
                        <div className="card" onClick={() => openProductPreview(data)}  key={data.id}>
                            <ProductCard
                                name={data.name}
                                img={data.images && data.images[0].url}
                                prevPrice={data.originalPrice}
                                price={data.discountPrice}
                                rating={data.ratings}
                                
                            />
                        </div>
                        <div className="remove"  onClick={() => removeItem(data.id)}><button>Remove from wishlist</button></div>
                    </div>
                </>
            })
        }
        
        </div>

        {/* <section className="pagination">
            <Pagination total={10} value={activePage} onChange={setPage} boundaries={1} color="rgb(2, 79, 2)" size={window.innerWidth <= 400 ? "xs" : "md"}/>
        </section> */}

        <section>
            <ProductPreview modal={productPreview} onClose={closeProductPreview} data={data}/>
        </section>
        <ServiceCard/>
        <Footer/>


    </>

}

export default WishList